function init(wpd, dataEntryVM) {
	wpd.XYGraphPointTool = class {
		constructor(axes) {
			this.axes = axes;

			this.drawPoints();
		}

		onRedraw() {
			this.drawPoints();
		}

		drawPoints() {
			const drawPoint = (point, label = "") => {
				if (point) {
					const color = point.isSelected ? wpd.Colors.active : wpd.Colors.good;
					wpd.graphicsHelper.drawPoint(
						{ x: point.px, y: point.py },
						color,
						label,
					);
				}
			};

			drawPoint(this.axes.calibration.getPoint(0));
			drawPoint(this.axes.calibration.getPoint(1));
			drawPoint(this.axes.calibration.getPoint(2));
			drawPoint(this.axes.calibration.getPoint(3));
		}
	};

	wpd.AxesCornersTool = class {
		constructor(calibration, reloadTool) {
			(this.pointCount = 0),
				(this._calibration = calibration),
				(this.isCapturingCorners = true);
			this.reloadTool = reloadTool;
			this._isGrabbing = false;
			this._grabPtIndex = -1;
			if (reloadTool) {
				this.pointCount = this._calibration.maxPointCount;
				this.isCapturingCorners = false;
			} else {
				if (dataEntryVM.reworkXYGraphCalibration) {
					this.pointCount = this._calibration.getCount();
					if (this.pointCount === this._calibration.maxPointCount) {
						this.isCapturingCorners = false;
						wpd.xyGraphEdit.enableDefineAxisPointsButton();
					} else {
						this.isCapturingCorners = true;
					}
				} else {
					this.pointCount = 0;
					this.isCapturingCorners = true;
					wpd.graphicsWidget.resetData();
				}
			}
		}

		onMouseMove(ev, pos, imagePos) {
			if (this._calibration.getCount() != this._calibration.maxPointCount) {
				return;
			}
			const ptIndex = this._calibration.findNearestPoint(
				imagePos.x,
				imagePos.y,
			);
			if (ptIndex >= 0) {
				ev.target.style.cursor = this._isGrabbing ? "grabbing" : "grab";
			} else {
				ev.target.style.cursor = "crosshair";
			}

			if (this._isGrabbing) {
				// move this calibration point to the mouse location
				this._calibration.changePointPx(
					this._grabPtIndex,
					imagePos.x,
					imagePos.y,
				);
				wpd.graphicsWidget.forceHandlerRepaint();
			}
		}

		onMouseDown(ev, pos, imagePos) {
			if (this._calibration.getCount() != this._calibration.maxPointCount) {
				return;
			}
			const ptIndex = this._calibration.findNearestPoint(
				imagePos.x,
				imagePos.y,
			);
			if (ptIndex >= 0) {
				this._isGrabbing = true;
				this._grabPtIndex = ptIndex;
				this._calibration.unselectAll();
				this._calibration.selectPoint(ptIndex);
			}
		}

		onMouseUp(ev, pos, imagePos) {
			this._isGrabbing = false;
		}

		onMouseClick(ev, pos, imagePos) {
			if (this.isCapturingCorners) {
				this.pointCount = this.pointCount + 1;

				if (dataEntryVM.reworkXYGraphCalibration) {
					this._calibration.addPoint(imagePos.x, imagePos.y, "0", "0");
				} else {
					this._calibration.addPoint(imagePos.x, imagePos.y, 0, 0);
				}

				this._calibration.unselectAll();
				this._calibration.selectPoint(this.pointCount - 1);
				wpd.graphicsWidget.forceHandlerRepaint();

				if (this.pointCount === this._calibration.maxPointCount) {
					this.isCapturingCorners = false;

					if (dataEntryVM.reworkXYGraphCalibration) {
						wpd.xyGraphEdit.enableDefineAxisPointsButton();
					} else {
						wpd.alignAxes.calibrationCompleted();
					}
				}
				wpd.graphicsWidget.updateZoomOnEvent(ev);
			} else {
				this._calibration.unselectAll();
				// cal.selectNearestPoint(imagePos.x,
				// imagePos.y, 15.0/wpd.graphicsWidget.getZoomRatio());
				this._calibration.selectNearestPoint(imagePos.x, imagePos.y);
				wpd.graphicsWidget.forceHandlerRepaint();
				wpd.graphicsWidget.updateZoomOnEvent(ev);
			}
		}

		onKeyDown(ev) {
			if (this._calibration.getSelectedPoints().length === 0) {
				return;
			}

			let selPoint = this._calibration.getPoint(
				this._calibration.getSelectedPoints()[0],
			);
			let pointPx = selPoint.px;
			let pointPy = selPoint.py;
			let stepSize =
				ev.shiftKey === true
					? 5 / wpd.graphicsWidget.getZoomRatio()
					: 0.5 / wpd.graphicsWidget.getZoomRatio();

			// rotate to current rotation
			const currentRotation = wpd.graphicsWidget.getRotation();
			let { x, y } = wpd.graphicsWidget.getRotatedCoordinates(
				0,
				currentRotation,
				pointPx,
				pointPy,
			);

			if (wpd.keyCodes.isUp(ev.keyCode)) {
				y = y - stepSize;
			} else if (wpd.keyCodes.isDown(ev.keyCode)) {
				y = y + stepSize;
			} else if (wpd.keyCodes.isLeft(ev.keyCode)) {
				x = x - stepSize;
			} else if (wpd.keyCodes.isRight(ev.keyCode)) {
				x = x + stepSize;
			} else {
				return;
			}

			// rotate back to original rotation
			({ x, y } = wpd.graphicsWidget.getRotatedCoordinates(
				currentRotation,
				0,
				x,
				y,
			));

			this._calibration.changePointPx(
				this._calibration.getSelectedPoints()[0],
				x,
				y,
			);
			wpd.graphicsWidget.forceHandlerRepaint();
			wpd.graphicsWidget.updateZoomToImagePosn(x, y);
			ev.preventDefault();
			ev.stopPropagation();
		}
	};
}

export { init };
